var map = {
	"./demo/demo_coffee.jpg": 1996,
	"./finish_reg.png": 6864,
	"./finish_reg_hse.png": 1423,
	"./flags/de.png": 9792,
	"./flags/en.png": 778,
	"./flags/es.png": 1295,
	"./flags/fr.png": 2524,
	"./flags/it.png": 3266,
	"./flags/tl1.png": 5535,
	"./flags/tl2.png": 3124,
	"./hse-logo.svg": 4405,
	"./icons/facebook.png": 3868,
	"./icons/google.png": 691,
	"./icons/icon-play.png": 1480,
	"./icons/icon-stop.png": 1706,
	"./icons/mark-info.png": 8758,
	"./icons/mark-keyword.png": 1511,
	"./logo.svg": 5411,
	"./logo_icon.svg": 3930,
	"./pb-congrat-leg.jpg": 8326,
	"./pb-congrat.jpg": 7062,
	"./training_intro.png": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;